import React, { FC, HTMLProps, useReducer } from 'react';
import styled from 'styled-components';
import EyeIcon from '../../icons/Eye';
import EyeOffIcon from '../../icons/EyeOff';
type Variant = 'default' | 'disabled';
type ContainerProps = {
  icon?: React.ReactElement;
  variant?: Variant;
} & React.HTMLProps<HTMLDivElement>;
/* eslint-disable @typescript-eslint/no-unused-vars */
const ContainerComponent: FC<ContainerProps> = ({
  icon,
  children,
  ...props
}) => {
  return <div {...props}>{children}</div>;
};

const Container = styled(ContainerComponent)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  stroke: var(--gray-500);
  ${({ variant }) =>
    variant === 'disabled'
      ? `
		cursor: not-allowed;
		background-color: var(--gray-50);
	`
      : ''}

  svg {
    position: absolute;
    left: 1rem;
    top: 0;
    height: 100%;
  }
  div svg {
    left: auto;
    right: 1rem;
  }
  input {
    ${({ variant }) =>
      variant === 'disabled'
        ? `
			cursor: default;
			background-color: var(--gray-50);
			color: var(--gray-500);
		`
        : 'color: var(--gray-700);'}
    width: 100%;
    border: 1px solid var(--gray-300);
    border-radius: 8px;
    padding: 0.8rem 1rem;
    ${({ icon }) => `padding-left: ${icon ? '2.8rem' : '1rem'};`}
    padding-right: 2.8rem;
    box-shadow: var(--box-shadow);
    transition: 0.2s;

    &:hover {
      border: 1px solid var(--gray-400);
    }
    &:focus {
      outline: 1px solid var(--gray-700);
    }
    &::placeholder {
      color: var(--gray-500);
      opacity: 1;
    }
  }
`;

const Label = styled.p`
  font-size: 0.9rem;
  margin-bottom: 0.375rem;
  color: var(--gray-700);
`;

type Props = {
  className?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  icon?: React.ReactElement;
  variant?: Variant;
  label?: string;
} & HTMLProps<HTMLInputElement>;
const PasswordInput: FC<Props> = ({
  className,
  onChange,
  icon,
  variant = 'default',
  label,
  type,
  ...props
}) => {
  const [visible, switchVisible] = useReducer((p: boolean) => !p, false);

  return (
    <>
      {label && <Label>{label}</Label>}
      <Container className={className} icon={icon} variant={variant}>
        <input
          {...props}
          type={visible ? 'text' : 'password'}
          onChange={onChange}
        />
        {icon}
        <div
          onClick={() => {
            switchVisible();
          }}
        >
          {visible ? <EyeIcon /> : <EyeOffIcon />}
        </div>
      </Container>
    </>
  );
};

export default PasswordInput;
